import fetchData, { setPokusStatus } from '../service/pokusService';
import browserUtils, { getDvid } from './browserUtils';
import { getAffiliate, getMMT_HLD_OBJ, isNonMmtAffiliate } from './appUtils';
import { CTA_DEFAULT_TEXT } from '../constants/appConstant';
import { getCookie, setCookie } from '../service/cookieService';
import { MMT_POKUS_VAR } from '../constants/mmtGlobal';

const affSuffix = isNonMmtAffiliate() ? `-${getAffiliate().toLowerCase()}` : '';
const DEVICE_ID_NAME = `dvid${affSuffix}`;

export default async function getValues() {
  const setDefaultValue = (_, defaultValue) => defaultValue;
  const initialDate = new Date();
  let finalDate;
  let response = null;
  try {
    if (response === null) {
      let mcid = getCookie(DEVICE_ID_NAME);
      if (!mcid) {
        mcid = browserUtils.getUUID();
        if (isNonMmtAffiliate()) {
          setCookie(DEVICE_ID_NAME, mcid, { maxAge: 365 });
        } else {
          mcid = getDvid();
        }
      }
      response = await fetchData(mcid);
      if (response) {
        const getExperimentDetailsList = expDetailsList => {
          if (!expDetailsList || !Array.isArray(expDetailsList)) {
            return [];
          }
          return expDetailsList.map(
            detail =>
              `${detail.exp_experiment_id}|${detail.exp_experiment_version}|${detail.exp_experiment_variant_id}`
          );
        };

        const getVariantKeysList = variantKey => {
          if (!variantKey) {
            return '';
          }
          return variantKey.split(',').join(',');
        };

        const experimentDetails = getExperimentDetailsList(
          response?.data?.perLobMap?.HOLIDAY?.exp_experiment_details_list
        );
        const variantKeys = getVariantKeysList(response?.data?.perLobMap?.HOLIDAY?.variantKey);
        sessionStorage.setItem(
          MMT_POKUS_VAR,
          JSON.stringify({
            valid_exp_list: experimentDetails,
            variant_keys: variantKeys,
            honoured_exp_list: [],
          })
        );
      }
      finalDate = new Date();
      const time = Math.round(finalDate - initialDate);
      setPokusStatus({
        code: 'POKUS_SUCCESS',
        message: `Pokus data recieved and set successfully! timetaken: ${time} ms`,
      });
    }
  } catch (e) {
    finalDate = new Date();
    const time = Math.round(finalDate - initialDate);
    setPokusStatus({
      code: 'POKUS_FAILED',
      message: `error while pokus call : ${e.message} timetaken: ${time} ms`,
    });
    return setDefaultValue;
  }
  if (!response?.data?.perLobMap?.HOLIDAY?.metadataValues) {
    setPokusStatus({
      code: 'POKUS_FAILED',
      message: 'error while pokus call : data not recieved in api for holidays',
    });
    return setDefaultValue;
  }
  if (isNonMmtAffiliate()) {
    setCookie(`AllocationTracking${affSuffix}`, response.data.perLobMap.HOLIDAY.variantKey, {
      maxAge: 365,
    });
  } else {
    setCookie('AllocationTracking', response.data.perLobMap.HOLIDAY.variantKey, {
      maxAge: 365,
      domain: '.makemytrip.com',
    });
  }

  return (params, defaultValue = null) => {
    if (response.data.perLobMap.HOLIDAY.metadataValues.hasOwnProperty(params)) {
      return response.data.perLobMap.HOLIDAY.metadataValues[params];
    }
    return defaultValue;
  };
}

export const getCTAControlledConfig = pageName => {
  const ctaData = getMMT_HLD_OBJ()?.HolidaysCtaData?.HolidaysCtaData;
  if (!ctaData || ctaData.length === 0) {
    return [];
  }
  const retData = ctaData.find(items =>
    items.pages.some(page => page.toLowerCase() === pageName.toLowerCase())
  );
  if (!retData) {
    return ctaData.find(item => item.pages.some(page => page === 'ALL'));
  }
  return retData;
};

export const buttonsData = pageName => {
  const cta = getCTAControlledConfig(pageName);
  const buttonDataObj = {
    ctaIconUrl: '',
    ctaText: CTA_DEFAULT_TEXT.FALLBACK_TEXT,
    chatIconUrl: '',
    chatText: CTA_DEFAULT_TEXT.LIVE_CHAT,
    branchLocatorIconURL: '',
    branchLocatorText: CTA_DEFAULT_TEXT.FIND_A_BRANCH,
    webQueryIconUrl: '',
    webQueryText: CTA_DEFAULT_TEXT.GET_A_CALLBACK,
    callUsIconUrl: '',
    callUsText: CTA_DEFAULT_TEXT.CALL_US,
  };
  if (cta) {
    if (cta?.ctaIconUrl) {
      buttonDataObj.ctaIconUrl = cta.ctaIconUrl;
    }
    if (cta?.ctaText) {
      buttonDataObj.ctaText = cta.ctaText;
    }
    if (cta?.chatIconUrl) {
      buttonDataObj.chatIconUrl = cta.chatIconUrl;
    }
    if (cta?.chatText) {
      buttonDataObj.chatText = cta.chatText;
    }
    if (cta?.branchLocatorIconURL) {
      buttonDataObj.branchLocatorIconURL = cta.branchLocatorIconURL;
    }
    if (cta?.branchLocatorText) {
      buttonDataObj.branchLocatorText = cta.branchLocatorText;
    }
    if (cta?.webQueryIconUrl) {
      buttonDataObj.webQueryIconUrl = cta.webQueryIconUrl;
    }
    if (cta?.webQueryText) {
      buttonDataObj.webQueryText = cta.webQueryText;
    }
    if (cta?.callIconUrl) {
      buttonDataObj.callUsIconUrl = cta.callIconUrl;
    }
    if (cta?.callText) {
      buttonDataObj.callUsText = cta.callText;
    }
  }
  return buttonDataObj;
};
